import FeatureGates from '@atlaskit/feature-gate-js-client';
import { isCSMHelpCenter } from '@atlassian/help-center-common-util/advanced-help-center';
import { getEnv } from '@atlassian/help-center-common-util/env';

export const useIsCSMTypographyMigrationEnabled = (
	useWhiteListedRouteNamesCheck: boolean = false,
) => {
	if (useWhiteListedRouteNamesCheck) {
		return (
			FeatureGates.checkGate('enable_typography_token_migration_for_csm') &&
			isCSMHelpCenter(getEnv().helpCenterType)
		);
	}

	return (
		FeatureGates.checkGate('enable_typography_token_migration_for_csm') &&
		isCSMHelpCenter(getEnv().helpCenterType)
	);
};

export const UseTypographyMigratedComponent = (props: {
	children: React.ReactNode;
	migratedComponent: React.ReactNode;
}) => {
	const isCSMTypographyMigrationEnabled = useIsCSMTypographyMigrationEnabled();
	return isCSMTypographyMigrationEnabled ? props.migratedComponent : props.children;
};
